import PropTypes from 'prop-types';
import React from 'react';
import CustomModal from 'commons/modal/CustomModal';
import FormFooterWithAccess from 'commons/modal/FormFooterWithAccess';
import { Button } from '@progress/kendo-react-buttons';
import { Field, Form, FormElement } from '@progress/kendo-react-form';
import { FormFloatingNumericTextBox, FormInput, FormDropDownList } from 'commons/forms/form';
import { numValidator } from 'commons/forms/validators';
import { useGetAnnoncePlanQuery } from '../../../../redux/api/cache';

export default function AddProduitsAssignesModal(props) {
  const { data: plans } = useGetAnnoncePlanQuery();

  const handleSubmit = (dataItem) => {
    if (!props.annonce) {
      props.create({
        camp_seq: props.infos.camp_seq,
        media_cd: props.infos.media_cd,
        campr_date: props.infos.campr_date,
        diff_cd: props.infos.diff_cd,
        them_cd: props.infos.them_cd,
        div_num: props.infos.div_num,
        dept_cd: props.infos.dept_cd,
        usr_cd: props.infos.usr_cd,
        mf_format: props.infos.mf_format,
        prod_num: dataItem.prod_num,
        camprp_prix_reg: dataItem.camprp_prix_reg,
        camprp_prix_spec: dataItem.camprp_prix_spec
      });
    }
    else {
      props.create({
        ann_seq: props.infos.ann_seq,
        prod_num: dataItem.prod_num,
        annp_plan: dataItem.plans,
      });
    }
    props.toggleDialog();
  };

  const numeroProduitValidator = (e) => numValidator(e);

  return (
    <div>
      <CustomModal
        width={'45%'}
        title="Ajout d'un produit"
        onClose={props.toggleDialog}
        body={
          <Form
            onSubmit={handleSubmit}
            render={(formRenderProps) => (
              <FormElement>
                <fieldset className={'k-form-fieldset'}>
                  <div className='row'>
                    <div className='col-md-3'>
                      <Field
                        disabled={props.selectedRow !== undefined}
                        id={'prod_num'}
                        name={'prod_num'}
                        label={`Numéro de produit`}
                        type={"number"}
                        validator={numeroProduitValidator}
                        component={FormInput}
                        wrapperStyle={{ marginRight: '18px' }}
                      />
                    </div>
                    {!props.annonce && (
                      <div className='col-md-3'>
                        <Field
                          id={'camprp_prix_reg'}
                          name={'camprp_prix_reg'}
                          label={'Prix régulier'}
                          optional={false}
                          component={FormFloatingNumericTextBox}
                          rows={6}
                        />
                      </div>
                    )}
                    {!props.annonce && (
                      <div className='col-md-3'>
                        <Field
                          id={'camprp_prix_spec'}
                          name={'camprp_prix_spec'}
                          label={'Prix spécial'}
                          optional={false}
                          component={FormFloatingNumericTextBox}
                          rows={6}
                        />
                      </div>
                    )}
                    {props.annonce && (
                      <div className='col-md-3'>
                        <Field
                          id={'plans'}
                          name={'plans'}
                          label={'Plan'}
                          component={FormDropDownList}
                          data={plans?.data?.map((item) => item.plan)}
                          wrapperStyle={{
                            minWidth: '10rem',
                            zIndex: 3333,
                          }} />
                      </div>
                    )}
                  </div>
                </fieldset>
                <FormFooterWithAccess formRenderProps={formRenderProps} />
              </FormElement>
            )}
          />
        }
      />
      <div className="k-form-buttons" style={{ marginTop: '1rem' }}>
        <Button
          onClick={() => {
            this.props.save(this.state);
          }}
          className="blueButton">
          Enregistrer
        </Button>
      </div>
    </div>
  );
}

AddProduitsAssignesModal.propTypes = {
  infos: PropTypes.any,
  create: PropTypes.any,
  annonce: PropTypes.bool,
  selectedRow: PropTypes.shape({
    prod_num: PropTypes.any,
  }),
  toggleDialog: PropTypes.func,
};
